export default __webpack_public_path__ + "f87db029a7b6495c25a64e59396b9b56.png";